import styled from 'styled-components';

import { TextBodyBold, TextBodySmallNormal } from '@/core/components/Typography/Typography.styles';

import { getVariant } from '@/themes/typographyUtilis';

export const ModalContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: min(720px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.background.dark};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  gap: 16px;
`;

export const ModalTitle = styled(TextBodyBold)`
  margin: 0;
  text-transform: uppercase;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 50vh;
  padding: 0 24px;
  background-color: ${({ theme }) => theme.colors.background.dark};
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  max-height: 50vh;
  object-fit: contain;
`;

export const PreviewVideo = styled.video.attrs({
  referrerPolicy: 'no-referrer',
})`
  display: block;
  width: 100%;
  max-height: 50vh;
  background-color: #000;
  object-fit: contain;
`;

export const PreviewEmbed = styled.iframe`
  display: block;
  width: 100%;
  height: min(50vh, 400px);
  border: none;
  background-color: #000;
`;

export const PreviewFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

export const OpenVideoLink = styled.a`
  color: ${({ theme }) => theme.colors.active};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const MetadataSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px 24px;
  gap: 16px;
`;

export const FileName = styled(TextBodyBold)`
  margin: 0;
`;

export const FileInfo = styled(TextBodySmallNormal)`
  margin: 4px 0 0;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const InfoHeading = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.primaryText};
  ${getVariant({ variant: 'body1-bold' })}
`;

export const InfoRows = styled.dl`
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 0;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding: 12px 0;
  gap: 24px;

  &:last-child {
    border-bottom: none;
  }
`;

export const InfoLabel = styled.dt`
  margin: 0;
  color: ${({ theme }) => theme.colors.secondaryText};
  ${getVariant({ variant: 'body2-normal' })}
`;

export const InfoValue = styled.dd`
  margin: 0;
  color: ${({ theme }) => theme.colors.primaryText};
  text-align: right;
  ${getVariant({ variant: 'body2-normal' })}
`;
